<div class="row mt-2" *ngIf="!hasDedicatedQuestion()">
  <div class="col-2">
    <div style="padding-left: {{20*depth}}px">
      <select name="question_type_id" [(ngModel)]="newQuestion.type_id" class="form-control" bkInput>
        <ng-template ngFor let-questionType [ngForOf]='questionTypes'>
          <option [value]="questionType.id"
            *ngIf="(!questionType.dedicated_screen || (!questions.length && depth == 0)) && (!questionType.secondary_event_disabled || priority !== 'secondary_event')">
            {{questionType.label}}</option>
        </ng-template>
      </select>
    </div>
  </div>
  <div class="col-2">
    <select *ngIf="newQuestion.type_id == 'YN'" class="form-control" bkInput name="question_sub_type"
      [(ngModel)]="newQuestion.sub_type">
      <ng-template ngFor let-type [ngForOf]="REQUEST_FORM_SUB_TYPE">
        <option [value]="type.value">{{type.label}}</option>
      </ng-template>
    </select>
    <select *ngIf="newQuestion.type_id === 'MULTIPLE_RADIO'" class="form-control" bkInput name="new_question_radio_sub_type"
      [(ngModel)]="newQuestion.sub_type" (ngModelChange)="onRadioSubTypeChange(newQuestion)">
      <option *ngFor="let opt of MULTIPLE_RADIO_EVENT_DETAIL_SUB_TYPE" [value]="opt.value">{{opt.label}}</option>
    </select>
    <select *ngIf="newQuestion.type_id === 'NUMBER'" class="form-control" bkInput name="new_question_number_sub_type"
      [(ngModel)]="newQuestion.sub_type">
      <option *ngFor="let opt of NUMBER_SUB_TYPE" [value]="opt.value">{{opt.label || '(blank)'}}</option>
    </select>
    <select *ngIf="newQuestion.type_id === 'event_start_at'" class="form-control" bkInput name="new_question_date_time_sub_type"
      [(ngModel)]="newQuestion.sub_type">
      <option *ngFor="let opt of DATE_TIME_SUB_TYPE" [value]="opt.value">{{opt.label}}</option>
    </select>
    <select class="form-control mt-2" bkInput *ngIf="newQuestion.sub_type == 'IFYESSKIP' || newQuestion.sub_type == 'IFNOSKIP'"
      [(ngModel)]="newQuestion.skipScreen">
      <ng-template ngFor let-screen [ngForOf]="nextScreens">
        <option [value]="screen.index">{{screen.name}}</option>
      </ng-template>
      <option value="END">END</option>
    </select>
  </div>
  <div class="col-5">
    <textarea name="question_text" class="form-control" bkInput [(ngModel)]="newQuestion.text"></textarea>
    <ng-template [ngIf]="newQuestion.type_id && newQuestion.type_id.includes('MULTI') && !hasRadioEventDetailSubType(newQuestion)">
      <p class="text-center mb-1 mt-2">Choices:</p>
      <textarea rows="4" cols="60" name="choices-{{i}}" class="form-control" bkInput [(ngModel)]="newQuestion.choices"></textarea>
    </ng-template>
    <div *ngIf="hasRadioEventDetailSubType(newQuestion)" class="mt-2">
      <b>Choices</b> <small class="text-muted">(from event detail; remove only, at least one required)</small>
      <div *ngIf="getRadioChoiceList(newQuestion).length === 0" class="mt-1">
        <button type="button" bkButton size="sm" (click)="onRadioSubTypeChange(newQuestion)">Load options</button>
      </div>
      <ul class="list-group list-group-flush mt-1" *ngIf="getRadioChoiceList(newQuestion).length > 0">
        <li class="list-group-item d-flex justify-content-between align-items-center py-1" *ngFor="let choice of getRadioChoiceList(newQuestion); let i = index">
          <span>{{choice.label}}</span>
          <button type="button" bkButton kind="outlined" color="danger" size="sm" [disabled]="getRadioChoiceList(newQuestion).length <= 1"
            (click)="removeRadioChoice(newQuestion, i)">×</button>
        </li>
      </ul>
      <button type="button" bkButton kind="outlined" color="secondary" size="sm" class="mt-1" *ngIf="getRadioChoiceList(newQuestion).length > 0" (click)="onRadioSubTypeChange(newQuestion)">Reset to full list</button>
    </div>
  </div>
  <div class="col-2">
    <div *ngIf="newQuestion.type_id === 'attendee_count_estimate'">
      <label class="form-label">Min Attendee</label>
      <select class="form-control" bkInput name="question_min_attendee" [(ngModel)]="newQuestion.min_attendee">
        <option [value]="v" *ngFor="let v of [1,2,3,4,5,6,7,8,9]">{{v}}</option>
      </select>
    </div>
    <div *ngIf="newQuestion.type_id === 'NUMBER'">
      <label class="form-label">Minimum</label>
      <select class="form-control" bkInput name="question_min_number" [(ngModel)]="newQuestion.min">
        <option [ngValue]="null"></option>
        <option [value]="v" *ngFor="let v of [0,1,2,3,4,5,6,7,8,9,10]">{{v}}</option>
      </select>
    </div>
    <div class="form-check" *ngIf="needOptionalCheckbox(newQuestion)">
      <input type="checkbox" class="form-check-input" name="new_question_optional" [(ngModel)]="newQuestion.optional"
        id="new_question_optional">
      <label class="form-check-label" for="new_question_optional">Optional</label>
    </div>
    <div class="form-check" *ngIf="newQuestion.type_id === 'MULTIPLE_RADIO' || newQuestion.type_id === 'MULTIPLE_CHECK'">
      <input type="checkbox" class="form-check-input" name="new_question_other" [(ngModel)]="newQuestion.other"
        id="new_question_other">
      <label class="form-check-label" for="new_question_other">Other</label>
    </div>
  </div>
  <div class="col-1">
    <button type="button" bkButton (click)="onAddNewQuestion()">
      <i class="fa fa-plus"></i>
    </button>
  </div>
</div>